import { startOfDay } from 'date-fns';
import {
  DatePicker,
  FileUpload,
  GridAlpha,
  NumberInput,
  Text,
  useToasts,
  validateFiles,
} from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import { Field } from '../.';
import { zodValidateField } from '../../../../../common/schema/forms';
import { IeltsScoreSchema, dateOfExamSchema } from '../../../formSchemas';
import useFileValidation from './fileUploadValidate';

const IeltsScore = () => {
  const { t } = useTranslation();
  const toasts = useToasts();
  const { fileValidateUpload } = useFileValidation();

  return (
    <>
      <GridAlpha columns="repeat(27, 1fr)" rowGap={6} pb={6}>
        <GridAlpha.Item columnStart={1} columnEnd={28}>
          <Text>{t('loans.educationSummary.scoresText')}</Text>
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={1} columnEnd={{ xs: 28, md: 14 }}>
          <Field
            as={NumberInput}
            name="englishReadingScore"
            label={t('loans.educationSummary.readingScore')}
            required={t('loans.errors.readingScoreRequired')}
            step={0.5}
            validate={value => {
              return zodValidateField(
                IeltsScoreSchema(t),
                t('loans.educationSummary.readingScore'),
                value,
                toasts,
              );
            }}
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={{ xs: 1, md: 15 }} columnEnd={28}>
          <Field
            as={NumberInput}
            name="englishListeningScore"
            label={t('loans.educationSummary.listeningScore')}
            required={t('loans.errors.listeningScoreRequired')}
            step={0.5}
            validate={value => {
              return zodValidateField(
                IeltsScoreSchema(t),
                t('loans.educationSummary.listeningScore'),
                value,
                toasts,
              );
            }}
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={1} columnEnd={{ xs: 28, md: 14 }}>
          <Field
            as={NumberInput}
            name="englishSpeakingScore"
            label={t('loans.educationSummary.speakingScore')}
            required={t('loans.errors.speakingScoreRequired')}
            step={0.5}
            validate={value => {
              return zodValidateField(
                IeltsScoreSchema(t),
                t('loans.educationSummary.speakingScore'),
                value,
                toasts,
              );
            }}
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={{ xs: 1, md: 15 }} columnEnd={28}>
          <Field
            as={NumberInput}
            name="englishWritingScore"
            label={t('loans.educationSummary.writingScore')}
            required={t('loans.errors.writingScoreRequired')}
            step={0.5}
            validate={value => {
              return zodValidateField(
                IeltsScoreSchema(t),
                t('loans.educationSummary.writingScore'),
                value,
                toasts,
              );
            }}
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={1} columnEnd={{ xs: 28, md: 14 }}>
          <Field
            as={NumberInput}
            name="englishOverallScore"
            label={t('loans.educationSummary.overallScore')}
            required={t('loans.errors.overallScoreRequired')}
            step={0.5}
            validate={value => {
              return zodValidateField(
                IeltsScoreSchema(t),
                t('loans.educationSummary.overallScore'),
                value,
                toasts,
              );
            }}
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={{ xs: 1, md: 15 }} columnEnd={28}>
          <Field
            as={DatePicker}
            name="englishDateOfExam"
            label={t('loans.educationSummary.dateOfExam')}
            required={t('loans.errors.dateOfExamRequired')}
            validate={(value: string) => {
              return zodValidateField(
                dateOfExamSchema(t),
                t('loans.educationSummary.dateOfExam'),
                value,
                toasts,
              );
            }}
            granularity="day"
            minDate="1900-01-01T00:00:00.000Z"
            maxDate={startOfDay(new Date()).toISOString()}
            size="md"
          />
        </GridAlpha.Item>
        <GridAlpha.Item columnStart={1} columnEnd={28}>
          <Field
            as={FileUpload}
            size="sm"
            allowedFileTypes={['.jpeg', '.png', '.pdf', 'jpg']}
            helpText={t('loans.educationSummary.uploadHelpText')}
            name="englishTestScoreDocument"
            maxFileSize={20000000} // 20 MB
            label={t('loans.educationSummary.uploadTestScore')}
            required={t('loans.errors.englishExamDocumentRequired')}
            validate={value => validateFiles(value, 1)}
            uploadFile={fileValidateUpload}
          >
            <FileUpload.Button>
              {t('loans.educationSummary.browseFilesButtonText')}
            </FileUpload.Button>
          </Field>
        </GridAlpha.Item>
      </GridAlpha>
    </>
  );
};

export default IeltsScore;
